// get watched lesson give lesson id
export default function getWatchedLesson(watchedLessons, lessonId) {
  if (watchedLessons === undefined || watchedLessons === null) return null;
  return watchedLessons.find(
    (watchedLesson) => watchedLesson.lessonId === lessonId
  );
}
